"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var pik_booking_widget_1 = require("@cian/pik-booking-widget");
var redux_1 = require("redux");
var state_1 = require("../booking_widget/state");
function createAppStore(options) {
    var bookingWidgetContext = pik_booking_widget_1.createContext(options.booking);
    var initialState = {
        bookingWidget: tslib_1.__assign({}, state_1.initialBookingWidgetState, { context: bookingWidgetContext }),
    };
    var reducers = redux_1.combineReducers({
        bookingWidget: state_1.bookingWidgetReducer,
    });
    var store = redux_1.createStore(reducers, initialState);
    return store;
}
exports.createAppStore = createAppStore;



//////////////////
// WEBPACK FOOTER
// ./src/shared/state/store.ts
// module id = 249
// module chunks = 2